import { localReturnPath } from "@/lib/security-boundaries";

const AUTH_RETURN_PATH_KEY = "autar.auth.return-path";

function safeLocalPath(candidate: string | null): string | null {
  const path = localReturnPath(candidate);
  return path &&
    new URL(path, window.location.origin).pathname !== "/auth/callback"
    ? path
    : null;
}

export function rememberAuthReturnPath(candidate: string): void {
  const path = safeLocalPath(candidate);
  if (!path) {
    clearAuthReturnPath();
    return;
  }
  try {
    window.sessionStorage.setItem(AUTH_RETURN_PATH_KEY, path);
  } catch {
    // Storage can be unavailable in privacy-restricted browsers. OAuth still
    // succeeds; it simply falls back to Home after the callback.
  }
}

export function readAuthReturnPath(): string | null {
  try {
    return safeLocalPath(window.sessionStorage.getItem(AUTH_RETURN_PATH_KEY));
  } catch {
    return null;
  }
}

export function clearAuthReturnPath(): void {
  try {
    window.sessionStorage.removeItem(AUTH_RETURN_PATH_KEY);
  } catch {
    // See rememberAuthReturnPath: an unavailable store already has nothing to clear.
  }
}
